import { render, staticRenderFns } from "./footerMobile.vue?vue&type=template&id=5c882bc9&scoped=true"
import script from "./footerMobile.vue?vue&type=script&lang=ts"
export * from "./footerMobile.vue?vue&type=script&lang=ts"
import style0 from "./footerMobile.vue?vue&type=style&index=0&id=5c882bc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c882bc9",
  null
  
)

export default component.exports